(function () {
  const root = document.querySelector("[data-medeia-monitor-root]");

  if (!root) return;

  root.querySelectorAll("[data-medeia-monitor-scroll]").forEach((link) => {
    link.addEventListener("click", (event) => {
      const targetId = link.getAttribute("href");
      const target = targetId ? root.querySelector(targetId) : null;

      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  const revealTargets = root.querySelectorAll(
    ".medeia-monitor-benefit, .medeia-monitor-panel, .medeia-monitor-flow-card, .medeia-monitor-qa-card, .medeia-monitor-last .medeia-monitor-cta"
  );

  revealTargets.forEach((item) => item.classList.add("medeia-monitor-reveal"));

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-medeia-monitor-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: "0px 0px -10% 0px", threshold: 0.12 }
  );

  revealTargets.forEach((item) => observer.observe(item));
})();
